import type { ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'

type CartFeedbackContextType = {
  showCartFeedback: boolean
  idsToShow?: string[]
  openCartFeedback: (ids?: string[]) => void
  closeCartFeedback: () => void
  setIdsToShow: React.Dispatch<React.SetStateAction<string[]>>
}

const CartFeedbackContext = createContext<CartFeedbackContextType | undefined>(
  undefined
)

export const CartFeedbackProvider = ({ children }: { children: ReactNode }) => {
  const [showCartFeedback, setShowCartFeedback] = useState(false)
  const [idsToShow, setIdsToShow] = useState<string[]>([])

  const openCartFeedback = (ids?: string[]) => {
    if (ids) {
      setIdsToShow((prevIds) => {
        const uniqueIds = new Set([...prevIds, ...ids])

        return Array.from(uniqueIds)
      })
    }

    setShowCartFeedback(true)
  }

  const closeCartFeedback = () => {
    setShowCartFeedback(false)
    setIdsToShow([])
  }

  return (
    <CartFeedbackContext.Provider
      value={{
        showCartFeedback,
        idsToShow,
        openCartFeedback,
        closeCartFeedback,
        setIdsToShow,
      }}
    >
      {children}
    </CartFeedbackContext.Provider>
  )
}

export const useCartFeedback = () => {
  const ctx = useContext(CartFeedbackContext)

  if (!ctx) {
    throw new Error('useCartFeedback must be used inside CartFeedbackProvider')
  }

  return ctx
}
